import React from 'react'

interface TestChatTipCloseIconProps {
  className?: string
  width?: number
  height?: number
  color?: string
  opacity?: number
}

const TestChatTipCloseIcon: React.FC<TestChatTipCloseIconProps> = ({
  className,
  width = 32,
  height = 32,
  color = 'white',
  opacity = 0.3,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        opacity={opacity}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.4697 11.5303C10.1768 11.2374 10.1768 10.7626 10.4697 10.4697C10.7626 10.1769 11.2373 10.1769 11.5302 10.4697L15.9999 14.9395L20.4697 10.4697C20.7626 10.1769 21.2373 10.1769 21.5302 10.4697C21.8231 10.7626 21.8231 11.2374 21.5302 11.5303L17.0605 16L21.5302 20.4697C21.8231 20.7626 21.8231 21.2374 21.5302 21.5303C21.2373 21.8232 20.7626 21.8232 20.4697 21.5303L15.9999 17.0605L11.5302 21.5303C11.2373 21.8232 10.7626 21.8232 10.4697 21.5303C10.1768 21.2374 10.1768 20.7626 10.4697 20.4697L14.9394 16L10.4697 11.5303Z"
        fill={color}
      />
    </svg>
  )
}

export default TestChatTipCloseIcon
